import { DlpSecondaryOrderRejectedResponse } from 'apiConnector/secondary-market/dlpOrder/model';
import { dlpOrderApiConnector } from 'apiConnector/secondary-market/dlpOrder/order';
import { isHttpTimeoutError } from 'epic/apiErrorEpicHelper';
import { BackendError, NextWorkflowError } from 'models/NextWorkflowError';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, mergeMap, takeUntil } from 'rxjs/operators';
import {
  secondaryMarketDlpOrderPlacementFailedThunk,
  secondaryMarketDlpOrderPlacementReceivedThunk,
} from 'state/secondaryMarket/dlpOrder/order/order.thunks';
import type { EpicWithThunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';
import { extractHttpErrorMessage, extractTimeout } from 'utils/http/httpClient.model';

import { getTabRemoved$ } from '../utils';

function getRejections(payload: BackendError | undefined | null): readonly NextWorkflowError[] {
  if (payload === null || payload === undefined || payload?.rejections === undefined) {
    return [];
  }

  return payload.rejections;
}

export function placeDlpOrderEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { placeOrder } = dlpOrderApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_DLP_ORDER_PLACEMENT_REQUESTED'),
      mergeMap(({ tabId, request }) => {
        return placeOrder(request).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          mergeMap(response => of(secondaryMarketDlpOrderPlacementReceivedThunk(tabId, response))),
          catchError((err: HttpError) => {
            const response = err.payload as DlpSecondaryOrderRejectedResponse;
            const genericErrorMessage = extractHttpErrorMessage(err, { backend: 'dlp' });
            const isTimeout = isHttpTimeoutError(err);
            const timeout = extractTimeout(err);
            const rejections = getRejections(response);
            const orderId = response?.orderId;
            return of(
              secondaryMarketDlpOrderPlacementFailedThunk(
                tabId,
                isTimeout,
                genericErrorMessage,
                timeout,
                rejections,
                orderId,
              ),
            );
          }),
        );
      }),
    );
  };
}
